export default __webpack_public_path__ + "static/media/whiteCircle.6aeacab1.svg";